import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SDate, SHr, SIcon, SInput, SLoad, SNavigation, SNotification, SOrdenador, SPage, SPopup, SScrollView2, SText, STheme, SView } from 'servisofts-component';
import SSocket from 'servisofts-socket';
import Model from '../../../Model';
import AudioPlayer from '../Components/AutoPlayer';

const TagInput = ({ data, onAudioLoaded, selected }) => {
    const inputRef = React.useRef(null);

    return (
        <SView col={"xs-6"} row style={{ alignItems: "center", justifyContent: "center", alignContent: "center", alignSelf: "center" }}>
            <SInput
                ref={inputRef}
                type="select2"
                height={35}
                // width={200}
                placeholder="Sucursal..."
                options={data
                    // .filter(s => !selected.includes(s.key))
                    .map(s => s.descripcion)
                }
                onChangeText={e => {
                    console.log("eeeeeeeeee")
                    onAudioLoaded("");
                    selected("");
                    const descripcion = e;
                    const suc = data.find(s => s.descripcion === descripcion);

                    console.log("descripcion", descripcion);
                    console.log("suc encontrada:", suc);

                    if (selected) {
                        selected(suc?.key);
                    }

                    // SSocket.sendPromise({
                    //     component: "audio",
                    //     type: "reproducir_sucursal",
                    //     estado: "cargando",
                    //     key_usuario: Model.usuario.Action.getKey(),
                    //     key_sucursal: suc.key


                    // }).then((resp) => {
                    //     const url = SSocket.api.root + "audio/" + resp.data?.key + ".mp3";
                    //     if (onAudioLoaded) {
                    //         onAudioLoaded(url);
                    //     }

                    // }).catch(e => {

                    // })


                }}

            />
        </SView>
    );
};

class Coach extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sucursales: [],
            time: new Date()

        };
    }

    async componentDidMount() {

        this.timerID = setInterval(() => {
            this.setState({ time: new Date() });
        }, 1000);

        await SSocket.sendPromise({

            component: "sucursal",
            type: "getAll",
            estado: "cargando",
            key_usuario: this.props.state.usuarioReducer.usuarioLog.key,
        }).then(async (resp) => {
            this.setState({
                // sucursales: resp.data
                sucursales: Object.values(resp.data).filter(e => e.estado_app == 1)
            })

        }).catch(e => {

        })
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }




    async loadData() {

        var data = await SSocket.sendPromise({
            component: "audio",
            type: "getAll",
            estado: "cargando",
            key_usuario: this.props.state.usuarioReducer.usuarioLog.key,
        })

        if (!data) return <SLoad />;

        let datas = Object.values(data.data).map(e => ({
            ...e,
            sucursales: e.sucursales || []
        }));

        return datas;

    }





    render() {
        const { time, sucursales } = this.state;

        const hh = String(time.getHours()).padStart(2, "0");
        const mm = String(time.getMinutes()).padStart(2, "0");
        const ss = String(time.getSeconds()).padStart(2, "0");

        console.log("KEYSUC", this.state.key_sucursal)

        return (
            <SPage disableScroll title={"Audio Coach"} >

                <SView col={"xs-12"} center >
                    <SHr height={20} />
                    <SView col={"xs-10"} padding={20} card >
                        <SText center fontSize={18} bold>Audio Coach dinámica</SText>
                        <SHr height={20} />
                        <SView row center col={"xs-12"}>
                            <SIcon name='timer' height={30} width={30} fill={STheme.color.text} />
                            <SView width={15} />
                            <SText fontSize={22} bold>{hh}:{mm}:{ss}</SText>
                            <SHr height={20} />
                            <TagInput
                                data={sucursales}
                                onAudioLoaded={(audio) => {
                                    this.setState({ audio });
                                }}
                                selected={(key_suc) => {
                                    this.setState({ key_sucursal: key_suc });
                                }}

                            />
                            <SHr height={20} />
                            {/* <AudioPlayer src="https://calistenia.servisofts.com/images/audio/44b83e3e-bdd2-4ef1-8724-b8948493851d.mp3" /> */}
                            {/* {((this.state.audio) && (this.state.audio != "")) ? <AudioPlayer src={this.state?.audio} /> : <SText>Sin resultados</SText>} */}
                            {((this.state.key_sucursal)) ? <AudioPlayer key_sucursal={this.state.key_sucursal} /> : <SText>Sin resultados</SText>}



                        </SView>
                    </SView>
                </SView>

            </SPage>
        );
    }
}
const initStates = (state) => {
    return { state }
};
export default connect(initStates)(Coach);